import React, {useEffect, useState} from "react";
import {Link} from "react-router-dom";


const NavState = () => {
    const url = window.location.href;
    const [activePage, setActivePage] = useState(url);

    useEffect(() => {
        setActivePage(url);
    },[url])

    

    return(
            <div className='nav'>
                <ul>
                    <li className={activePage === 'http://localhost:3000/' ? ' active' : ''}><Link to='/'>Home</Link></li>
                    <li className={activePage === 'http://localhost:3000/news' ? ' active' : ''}><Link to='/news'>News</Link></li>
                    <li className={activePage === 'http://localhost:3000/about' ? ' active' : ''}><Link to='/about'>About</Link></li>
                </ul>
            </div>
    )
}

export default NavState;